module.exports = __webpack_public_path__ + "img/selo2.79e5033a.png";